import { REGION_CHANGE } from './regionActionTypes';

// eslint-disable-next-line import/prefer-default-export
export const regionChange = (region) => ({
    type: REGION_CHANGE,
    region,
});
